import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import { toast } from "react-toastify";
import { authHeaders,getSessionToken } from "../utils/session";

const AddNewTestimonials = () => {
  const [formData, setFormData] = useState({
    url: "",
    name: "",
    rating: "",
    description: "",
    city_country: "",
    image: "",
  });

  const { url, name, rating, metakeywords, description, city_country, image } =
    formData;

  const [errors, setErrors] = useState({});

  const [pageError, setPageError] = useState("");
  // const [image, setImage] = useState("");
  const [pageurlError, setPageurlError] = useState("");
  const [pageNameError, setPageNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [imageError, setImageError] = useState("");
  const [ratingError, setRatingError] = useState("");
  const [cityAndCountryError, setCityAndCountry] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [managePageData, setManagePageData] = useState();
  const [token, setToken] = useState(getSessionToken());

  const navigate = useNavigate();
  const { id } = useParams();

  const validateForm = () => {
    let errors = {};
    // check for empty values

    if (!formData.url) {
      errors.url = "Please Enter Url";
    }
    if (!formData.name) {
      errors.name = "Please enter Name";
    }
    if (!formData.image) {
      errors.image = "Please Upload Image";
    }
    if (!formData.rating) {
      errors.rating = "Please enter Rating";
    }
    return errors;
  };

  useEffect(() => {
    setToken(getSessionToken());
if(id){
  fetchPrefilled(id);
} 
  }, []);


  const fetchPrefilled = async (id) => {
    try {
      setToken(getSessionToken());
      // setIsLoading(true);

      const enquiryResponse = await axios.get(
        `${API_BASE_URL}/get-testimonial-id-basis?id=${id}`,
        {
          headers: {
            ...authHeaders(),
          },
        }
      );

      const enquiryRes = JSON.parse(JSON.stringify(enquiryResponse.data));
      // console.log(enquiryRes, "res");

      if (enquiryRes.status == 200) {
        // setIsLoading(false);
        setFormData({
          ...formData,
          url: enquiryRes.data.url,
          name: enquiryRes.data.name,
          rating: enquiryRes.data.rating,
          description: enquiryRes.data.description,
          city_country: enquiryRes.data.city_country,
          image: enquiryRes.data.image,
        });

        setImagePreview(enquiryRes.data.image);
      }
    } catch (error) {}
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const errors = validateForm();

    // console.log(image, "image");
    const form = new FormData();
    form.append("name", formData.name);
    form.append("city_country", formData.city_country);
    form.append("url", formData.url);
    form.append("rating", formData.rating);
    form.append("description", formData.description);
    form.append("image", image);

    if (Object.keys(errors).length === 0) {
      if (!id) {
        form.append("action", "add");

        axios
          .post(`${API_BASE_URL}/add-update-testimonial`, form, {
            headers: {
              ...authHeaders(),
            },
          })
          .then((response) => {
            // console.log(response.data.status, "status");
            if (response.data.status === 200) {
              navigate("/cms/managetestimonials");
              toast.success("Testimonial added successfully");
            }
          })
          .catch((error) => {
            setPageError(error.response.data.result);
          });
      } 
      else {
        form.append("action", "update");
        form.append("id", id);

        axios
          .post(`${API_BASE_URL}/add-update-testimonial`, form, {
            headers: {
              ...authHeaders(),
            },
          })
          .then((response) => {
            // console.log(response.data.status, "status");
            if (response.data.status === 200) {
              navigate("/cms/managetestimonials");
              toast.success(response.data.msg || "Testimonial updated successfully");
            }
          })
          .catch((error) => {
            setPageError(error.response.data.result);
          });
      }
    } else {
      setErrors(errors);
      console.log(errors);
    }
  };

  const handleEditorChangeDescription = (content, editor) => {
    setFormData({ ...formData, description: content });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });

    if (name === "image") {
      setFormData({ ...formData, [name]: event.target.files[0] });
      // setImage(event.target.files[0]);
    }
  };
  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    if (!selectedImage) {
      setImagePreview(null);
      return;
    }
    const objectUrl = URL.createObjectURL(selectedImage);
    setImagePreview(objectUrl);
  };
  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">
                  {`${id ? "Edit":" Add"} Testimonial`}  {" "}
                  </h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">CMS</a>
                      </li>
                      <li className="breadcrumb-item ">
                        <Link to={"/cms/managetestimonials"}>
                          Manage Testimoials 
                        </Link>
                      </li> 
                      <li className="breadcrumb-item active">
                      {`${id ? "Edit":" Add"} Testimonial`} 
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-4">{`${id ? "Edit":" Add"} Testimonials`} </h4>
                      <form onSubmit={handleSubmit}>
                        <div data-repeater-list="outer-group" className="outer">
                          <div data-repeater-item className="outer">
                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Name
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="taskname"
                                  name="name"
                                  type="text"
                                  value={name}
                                  className={
                                    errors.name
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter pagename..."
                                  onChange={handleInputChange}
                                />
                                {errors.name && (
                                  <div className="text-danger">
                                    {errors.name}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                City and country
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="taskname"
                                  name="city_country"
                                  type="text"
                                  value={city_country}
                                  className={
                                    cityAndCountryError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter city and country url..."
                                  onChange={handleInputChange}
                                />
                                {errors.city_country && (
                                  <div className="text-danger">
                                    {errors.city_country}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                URL
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="taskname"
                                  name="url"
                                  type="text"
                                  value={url}
                                  className={
                                    errors.url
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter page url..."
                                  onChange={handleInputChange}
                                />
                                {errors.url && (
                                  <div className="text-danger">
                                    {errors.url}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Ratings
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="taskname"
                                  name="rating"
                                  type="text"
                                  value={rating}
                                  className={
                                    errors.rating
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter rating..."
                                  onChange={handleInputChange}
                                />
                                {errors.rating && (
                                  <div className="text-danger">
                                    {errors.rating}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="form-group row mb-4">
                              <label className="col-form-label col-lg-2">
                                Description
                              </label>
                              <div className="col-lg-10">
                                <Editor
                                  onEditorChange={handleEditorChangeDescription}
                                  value={description}
                                  init={{
                                    plugins:
                                      "print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
                                    table_default_attributes: {
                                      border: "5",
                                    },
                                  }}
                                />
                              </div>
                            </div>

                            <div className="inner-repeater mb-4">
                              <div
                                data-repeater-list="inner-group"
                                className="inner form-group mb-0 row"
                              >
                                <label className="col-form-label col-lg-2">
                                  Image
                                </label>
                                <div
                                  data-repeater-item
                                  className="inner col-lg-10 ms-md-auto"
                                >
                                  <div className="mb-3 row align-items-center">
                                    <div className="col-md-12">
                                      <div className="mt-4 mt-md-0">
                                        <input
                                          className={
                                            errors.image
                                              ? "form-control is-invalid"
                                              : "form-control "
                                          }
                                          name="image"
                                          type="file"
                                          accept="image/*"
                                          onChange={(e) => {
                                            handleImageChange(e);
                                            handleInputChange(e);
                                          }}
                                        />
                                        {errors.image && (
                                          <div className="text-danger">
                                            {errors.image}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="mt-4 mt-20">
                                        <div>
                                          {imagePreview && (
                                            <img
                                              src={imagePreview}
                                              alt="Preview"
                                              width="200"
                                              height="200"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row justify-content-end">
                          <div className="col-lg-10">
                            {pageError && (
                              <div className="alert alert-danger" role="alert">
                                {pageError}
                              </div>
                            )}
                            <button type="submit" className="btn btn-primary">
                            {`${id ? "Update":" Add"} Testimonial`} 
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewTestimonials;
